module.exports = __webpack_public_path__ + "media/icons/header-icon-a34ac02a.svg";